import { render, staticRenderFns } from "./DepartmentChatIcon.vue?vue&type=template&id=2e94de61"
import script from "./DepartmentChatIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports